export default __webpack_public_path__ + "static/media/close-icon-gray.72ac8bc9.svg";